<template>
    <div>
        <div class="atl_agent_form">
        <div class="row">
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div class="card dash-widget">
                    <div class="card-body">
                        <span class="dash-widget-icon"><i class="fas fa-user-tie"></i></span>
                        <div class="dash-widget-info">
                            <h3>{{agents.length}}</h3>
                            <span>Agents</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div class="card dash-widget">
                    <div class="card-body">
                        <span class="dash-widget-icon"><i class="far fa-building"></i></span>
                        <div class="dash-widget-info">
                            <h3>{{total_companycounts}}</h3>
                            <span>Companies</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div class="card dash-widget">
                    <div class="card-body">
                        <span class="dash-widget-icon"><i class="fa fa-users"></i></span>
                        <div class="dash-widget-info">
                            <h3>{{total_employeecounts}}</h3>
                            <span>Employees</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h4 class="mb-2 border-bottom pb-2 mt-5">{{pagetitle}}</h4>
        <div class="card border-0 mt-0 bg-wash no-shadow">
            <div class="card-header mb-3 px-0 bg-transparent border-0">
                <div class="float-left ml-0 custom-search col-md-6 pl-0">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search Agent" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
                <div class="float-right col-md-6 text-right pr-0">
                    <b-button  id="show-btn" v-if="ce" @click="addNewAgent()"><b-icon icon="plus" ></b-icon> Setup New Agent</b-button>
                </div>
            </div>
    
            <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
    
            <b-overlay :show="showoverlay" rounded="sm">
            <div class="card-body container-fluid pt-1 table-layout agent-table px-0 py-0">
                <div class="row pt-0 pb-2 table-head no-margin w-50 border-custom-color float-left border-right border-10">
                    <div class="col-sm-4  px-0 py-1 pl-2 font-weight-bold align-self-center py-2 border-bottom">                
                        Name
                    </div>                
                    <div class="col-sm-3  px-0 py-1 align-self-center font-weight-bold py-2 border-bottom text-center">
                        Company Count
                    </div>
                    <div class="col-sm-3  px-0 py-1 pl-1 font-weight-bold align-self-center py-2 border-bottom">
                        Contact Person
                    </div>
                    <div class="col-sm-2  pl-0 pr-3 py-1 font-weight-bold align-self-center text-right py-2 border-bottom">
                        Action
                    </div>
                </div>
                <div class="row pt-0 pb-2 table-head no-margin w-50 border-custom-color float-right border-left border-10">
                    <div class="col-sm-4  px-0 py-1 pl-2 font-weight-bold align-self-center py-2 border-bottom">                
                        Name
                    </div>                
                    <div class="col-sm-3  px-0 py-1 align-self-center font-weight-bold py-2 border-bottom text-center">
                        Company Count
                    </div>
                    <div class="col-sm-3  px-0 py-1 pl-1 font-weight-bold align-self-center py-2 border-bottom">
                        Contact Person
                    </div>
                    <div class="col-sm-2  pl-0 pr-3 py-1 font-weight-bold align-self-center text-right py-2 border-bottom">
                        Action
                    </div>
                </div>
    
                <div class="clearfix"></div>
                <div style="min-height: 90px;" class="row border-bottom py-10 table-row no-margin w-50 border-custom-color border-10" :class="{'float-left border-right': index % 2 === 0, 'float-right border-left': index % 2 !== 0 }" v-for="(agent , index) in paginatedData" :key="agent.id">
    
                    <div class="col-sm-4 text-uppercase py-1 px-0 border-bottom">
                        <div class="row m-0 p-0 h-100">
                            <div class="col-sm-4 pl-2 py-2 cursor-pointer d-flex align-items-center" @click="companiesAgent(agent.id)">
                                <img v-bind:src="$api_url+'/images/agent/' + agent.logo"  class="img-fluid img-thumbnail agent-thumbnail" /> 
                            </div>
                            <div class="col-sm-8 p-0 align-self-center cursor-pointer" @click="companiesAgent(agent.id)">
                                {{agent.name}}
                            </div>
                        </div>                    
                    </div>                
                    <div class="col-sm-3 py-1 pl-2 border-bottom d-flex align-items-center justify-content-center">                    
                        <a href="javascript:void(0)" @click="companiesAgent(agent.id)">{{agent.no_of_conpanies}}</a>
                    </div>
                    <div class="col-sm-3  py-1 px-0 pl-1 border-bottom d-flex align-items-center">
                        {{agent.contact_name}}<br/>
                        {{agent.contact_email}}<br />{{agent.phone}}
                    </div>
                    <div class="col-sm-2 py-1 pl-0 pr-3 text-right position-relative border-bottom d-flex align-items-center justify-content-end">
                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                            <b-button-group >
                                <b-button variant="outline-secondary" v-if="ce" @click="editAgent(agent.id)">
                                    <i class="fa fa-pencil-alt"></i> Edit
                                </b-button>

                                 <template v-if="agent.no_of_conpanies == 0">
                                    <b-button variant="outline-secondary" v-if="ce" @click="passConfirm('deleteAgent' , agent.id)">
                                        <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                    </b-button>
                                </template>
        
                                <b-button variant="outline-secondary" v-if="ce" @click="usersAgent(agent.id)">
                                    <b-icon icon="people"></b-icon> Team
                                </b-button>
        
                                <b-button variant="outline-secondary"  @click="companiesAgent(agent.id)">
                                    <b-icon icon="building"></b-icon> Companies
                                    <!-- this will set the agent id in session and redirect to company list page -->
                                </b-button>
                            
                            </b-button-group>
                        </div>
                    </div>
                </div>
                
                <div class="row py-2 float-right no-margin" v-if="paginatedData.length > 0">
                    <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                </div>
                <div class="row py-2 no-margin" v-if="paginatedData.length == 0">
                    {{blankmsg}}
                </div>
            </div>
            </b-overlay>
            
            
            <b-modal id="bv-modal-example-agent"  size="lg" hide-footer no-close-on-backdrop title="Agent Info">
                
    
                    <!--<ul class="list-group mb-3 " v-if='errormsg'>           
                        <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                    </ul>-->
    
                    <b-overlay :show="showoverlaymodal" rounded="sm" class='agent_modal'>
                        <b-form @submit.stop.prevent="onSubmit">
                            <input type="hidden" v-model="fdata.id" name="id">
    
                            <b-form-group id="name-group" class="half-width mr1" label="Agent Name" label-for="name">
                                <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Agent Name"></b-form-input>
                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                            </b-form-group>
    
                            <!-- The following inputs will be appeared for new agent form -->
                            <template v-if="newagent">
    
                                <b-form-group class="reuired half-width" id="contact_name-group" label="Contact Person Name" label-for="name">
                                    <b-form-input id="contact_name" name="contact_name" v-model="fdata.contact_name" v-validate="{ required: true, min: 3 }" :state="validateState('contact_name')" aria-describedby="name-feedback" data-vv-as="Contact Person Name"></b-form-input>
                                    <b-form-invalid-feedback id="contact_name-feedback">{{ veeErrors.first('contact_name') }}</b-form-invalid-feedback>
                                </b-form-group>
                            
                                <b-form-group id="email-group" class="half-width mr1" label="Contact Person Email" label-for="email" >
                                    <b-form-input id="email" name="email" type="email" v-model="fdata.email" v-validate="{ required: true, min: 3 , email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Contact Person Email"></b-form-input>
                                    <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                </b-form-group>
    
                                <b-form-group id="phone-group" label="Phone" class="required-field half-width" label-for="phone">                            
                                    <b-input-group prepend="+880">                            
                                        <b-form-input id="phone" name="phone" v-model="fdata.phone" v-validate="{ required: true, min: 10 , max:10 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Contact Number"></b-form-input>
                                        <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
    
                                
                            </template>
                            <template v-else>
                                <b-form-group id="admin_id-group" class="half-width" label="Assigned Admin User" label-for="admin_id" >
                                    <b-form-select id="admin_id" name="admin_id" v-model="fdata.admin_id" v-validate="{ required: true }" :options="admin_ids" :state="validateState('admin_id')" aria-describedby="status-feedback" data-vv-as="Assigned Admin User"></b-form-select>
                                    <b-form-invalid-feedback id="admin_id-feedback">{{ veeErrors.first('admin_id') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </template>
    
                            <!-- ends here -->
    
                            <div id="company_logo-group" role="group" class="form-group half-width mr1">
                                <label id="company_logo-group__BV_label_" for="company_logo" class="d-block">Logo</label>
                                <div class="bv-no-focus-ring cmpny-logo-uploader" :class="{ 'no-logo': !logoUrl }">                           
                                    <my-upload field="img"
                                        @crop-success="cropSuccess"
                                        v-model="showLogoUploader"
                                        lang-type="en"
                                        :width="400"
                                        :height="400"
                                        img-format="jpeg"></my-upload>
    
                                    <img :src="logoUrl"  @click="toggleLogoUploader" style="cursor: pointer;">
                                    <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload</div>
                                </div>
                            </div>
    
                            
                            <b-form-group class="reuired half-width" id="address-group" label="Address" label-for="address">
                                <b-form-textarea id="address" name="address" v-model="fdata.address" v-validate="{ required: true, min: 3 }" :state="validateState('address')" aria-describedby="address-feedback" data-vv-as="Address"></b-form-textarea>
                                <b-form-invalid-feedback id="address-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                            </b-form-group>
    
                            <b-form-group id="etin-group" class="half-width mr1" label="eTin" label-for="etin">
                                <b-form-input id="etin" name="etin" v-model="fdata.etin" v-validate="{  min: 12 , max: 12 }" :state="validateState('etin')" aria-describedby="etin-feedback" data-vv-as="eTin"></b-form-input>
                                <b-form-invalid-feedback id="etin-feedback">{{ veeErrors.first('etin') }}</b-form-invalid-feedback>
                            </b-form-group>
    
                            <b-form-group id="bin-group" class="half-width" label="BIN" label-for="bin">
                                <b-form-input id="bin" name="bin" v-model="fdata.bin" v-validate="{   }" :state="validateState('bin')" aria-describedby="bin-feedback" data-vv-as="BIN"></b-form-input>
                                <b-form-invalid-feedback id="bin-feedback">{{ veeErrors.first('bin') }}</b-form-invalid-feedback>
                            </b-form-group>
    
                            <!--<b-form-group class="reuired half-width mr1" id="contact_details-group" label="Contact Details" label-for="contact_details">
                                <b-form-textarea id="contact_details" name="contact_details" v-model="fdata.contact_details" v-validate="{ required: true, min: 3 }" :state="validateState('contact_details')" aria-describedby="contact_details-feedback" data-vv-as="Contact Details"></b-form-textarea>
                                <b-form-invalid-feedback id="contact_details-feedback">{{ veeErrors.first('contact_details') }}</b-form-invalid-feedback>
                            </b-form-group>-->
                            
                                                    
    
                            
                            <b-form-group id="single_company-group" class="half-width mr1" label="Single Company" label-for="single_company">
                                <b-form-select id="single_company" name="single_company" v-model="fdata.single_company" :options="single_company_data"></b-form-select>
                            </b-form-group>
                            
                            <b-form-group id="status-group" class="half-width" label="Status" label-for="status">
                                <b-form-select id="status" name="status" v-model="fdata.status" v-validate="{ required: true }" :options="status" :state="validateState('status')" aria-describedby="status-feedback" data-vv-as="Status"></b-form-select>
                                <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
                            </b-form-group>
                             <div class="full-width">
                                <b-button type="submit" variant="success" >Submit</b-button>
                                <b-button class="ml-2" variant="success" @click="resetForm()">Reset</b-button>
                             </div>
                        </b-form> 
                    </b-overlay>               
            </b-modal>
    
        </div>
        <template v-if="showpassconfirm">
            <pass-confirm-form :the_id="this.the_id" :fun_name="this.fun_name"></pass-confirm-form>
        </template>
        </div>
    </div>
</template>


<script>
    import myUpload from 'vue-image-crop-upload';
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
            
        },
        components: {'my-upload': myUpload, },
        data(){            
            
            return {
                cu : window.location.href,
                ce : false, 
                newagent : false,                 
                agent_list : true,
                user_list : false,
                pagetitle: 'Agents',
                search:'',
                listdata : [],                 
                agents : [],                 
                successmsg : '',
                errormsg : [],
                blankmsg : 'Fetching data..',
                fdata : {status:null , single_company:0, id:null, email:null, phone:null, admin_id:null , address:'' , etin:'' , bin:'' , contact_details:''},
                
                file : null,
                admin_ids: [],
                
                total_companycounts: '',
                total_employeecounts: '',

                showoverlay : false,
                showoverlaymodal : false,
                showoverlaymodal_inner : false,

                status: [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Active" },
                    { value: "2", text: "Pending" },
                    { value: "3", text: "Not Approved" },
                    { value: "4", text: "Other" },
                ],

                single_company_data: [
                    
                    { value: "1", text: "Yes" },
                    { value: "0", text: "No" },
                ],


                
                length: 10,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                
                logoUrl : this.$api_url + '/images/company/' + 'demo.jpg',
                logoUploaded: false,
                showLogoUploader: false,

                showpassconfirm : false,                
                fun_name : '',
                the_id : '',

            }
        },
        methods:{
            toggleLogoUploader() {
				this.showLogoUploader = !this.showLogoUploader;
			},
            cropSuccess(imgDataUrl, field){
				
				this.logoUrl = imgDataUrl;
                this.logoUploaded = true;
			},
            getAcl: function()
            {                
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },
            getAgentData: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/agent/listdetails' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.agents = response.data;
                    this.pagination.total = response.data.length;
                    
                    let total_companycounts = 0;
                    let total_employeecounts = 0;

                    for (let [key, value] of Object.entries(this.agents)) 
                    {
                        total_companycounts = total_companycounts + value.no_of_conpanies;
                        total_employeecounts = total_employeecounts + value.no_of_total_employees;
                    }
                    this.total_companycounts = total_companycounts;
                    this.total_employeecounts = total_employeecounts;

                    this.showoverlay = false;

                    if(this.agents.length == 0)
                        this.blankmsg = "Nothing found.";
                }.bind(this));
            }, 
            editAgent:function(x)
            { 
                if(!this.checkNet()) return false;
                let currentObj = this;

                this.newagent = false;        
                this.errormsg = [];
                this.successmsg = '';
                
                
                let formData = new FormData();
                formData.append('id', x);
                axios.post(this.$api_url+'/agent/details', formData)
                    .then(function(response){
                    this.fdata.id = response.data.id;
                    this.fdata.name = response.data.name;
                    this.fdata.admin_id = response.data.admin_id;
                    this.fdata.status = response.data.status;
                    this.fdata.single_company = response.data.single_company;
                    

                    this.fdata.address = response.data.address;

                    if(response.data.etin == null)
                        this.fdata.etin = '';
                    else
                        this.fdata.etin = response.data.etin;

                    if(response.data.bin == null)
                        this.fdata.bin = '';
                    else
                        this.fdata.bin = response.data.bin;

                    this.fdata.contact_details = response.data.contact_details;


                    this.admin_ids = response.data.admin_ids;
                    this.logoUrl = this.$api_url + '/images/agent/' + response.data.logo;
                    this.file = null;
                    this.$validator.reset();
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.serverError(error);
                });

                this.$bvModal.show('bv-modal-example-agent');
                
            },

            passConfirm : function(fun_name , x)
            {                                               
                this.fun_name = fun_name;
                this.the_id = x;
                this.showpassconfirm = true;
            },
            deleteAgent : function(id)
            {                
                this.showpassconfirm = false;
                
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('id', id);
                axios.post(this.$api_url+'/agent/delete', formData)
                                .then(function (response) 
                                {                                                                              
                                    
                                    if(response.data.status)
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        }); 

                                        setTimeout(function () {location.reload();  }.bind(this), 1000); 
                                    }
                                    else
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        }); 
                                    }                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});

                
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {name:null, status:null, single_company:0, email:null, id:null, phone:null , password:'pass1234' , password_confirmation:'pass1234'};
                
                this.file = null;

                this.$nextTick(() => {
                    this.$validator.reset();
                });

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNewAgent()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-example-agent');
                this.newagent = true;
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlaymodal = true;
                    this.showoverlaymodal_inner = true;
                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                    
                    if(this.logoUploaded)
                        formData.append('logo', this.logoUrl);
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/agent/save', formData, config)
                                .then(function (response) 
                                {                             
                                    this.agents = response.data;
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        }); 

                                    this.$bvModal.hide('bv-modal-example-agent');
                                    this.showoverlaymodal = false;   
                                    this.showoverlaymodal_inner = false;                                 
                                    this.resetForm();

                                    this.getAgentData();
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {        
                                    currentObj.showoverlaymodal = false;   
                                    currentObj.showoverlaymodal_inner = false;                                   
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;                                    
                                    for (var data in currentObj.errormsg)
                                    {
                                        var msg = currentObj.errormsg[data];
                                        currentObj.$bvToast.toast(msg, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        }); 
                                        currentObj.$validator.reset();
                                    }

                                   
                                });
                });
            },

            usersAgent:function(x)
            {    
                if(!this.checkNet()) return false;   
                let currentObj = this;        
                let formData = new FormData();
                formData.append('agent_id', x);
                axios.post(this.$api_url+'/agent/setagent', formData)
                                .then(function (response) 
                                {                                                                    
                                    window.location.href = this.$api_url+'/agent/users';
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.serverError(error);
                                });

            },
            companiesAgent:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('agent_id', x);
                axios.post(this.$api_url+'/agent/setagent', formData)
                                .then(function (response) 
                                {                                                                    
                                    window.location.href = this.$api_url+'/company';
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.serverError(error);
                                    //currentObj.errormsg = error.response.data.errors;
                                });
            },
            backtoAget:function()
            {
                //this.agent_list = true;
                //this.user_list = false;
            },

        },
        created: function(){
            this.getAcl();
            this.getAgentData();
            Fire.$on('reloadUsers', () => {this.getAgentData()});
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.agents;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
<style> 
.b-overlay-wrap.position-relative.agent_modal {
	height: 600px;
}

.b-overlay-wrap.position-relative.agent_modal .b-overlay.position-absolute {
	height: 100%;
}
 
</style> 